module.exports = __webpack_public_path__ + "static/media/imgop_supergen-logo.fb894a31.webp";